import * as React from 'react'
import {
  CancelAppointmentDialog,
  CompleteAppointmentDialog,
} from '../AppointmentsCardElements'
import type { ENTITY_TYPES } from '@sales-center/common'
import Dialog from '@mui/material/Dialog'
import { useAppoimentDialogWrapperData } from '../hooks/useAppoimentDialogWrapperData'

interface Props {
  onClose: () => void
  onCloseMain: () => void
  appointmentId?: string
  open: boolean
  completeView: boolean
  entityId: number
  entityType: ENTITY_TYPES
}

export function AppointmentDialogWrapper(props: Props) {
  const { open, onClose, completeView } = props

  const { showCompleteModal } = useAppoimentDialogWrapperData({ completeView })

  if (showCompleteModal) {
    return (
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <CompleteAppointmentDialog {...props} />
      </Dialog>
    )
  }

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <CancelAppointmentDialog {...props} />
    </Dialog>
  )
}
